import React from 'react';
import { Trans } from 'react-i18next';
import { ExternalLink } from '~frontend-common/components/ui';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box, BoxProps } from '~ui-kit/components/box';
import { Typography } from '~ui-kit/components/typography';
import { styled } from '~ui-kit/styled-components';

export function HelpBox({ mt, mb }: Pick<BoxProps, 'mt' | 'mb'>) {
  const translator = useTranslator();
  const { tl, i18n } = translator;

  const contactEmail = 'support@youset.ca';

  return (
    <Container px={4} py={2} mt={mt} mb={mb} maxWidth="500px" flexDirection="column" alignItems="center">
      <Typography $fontSize="14px" $lineHeight="24px">
        {tl('auth.passcodeForm.helpLine1')}
      </Typography>
      <Typography $fontSize="14px" $lineHeight="24px">
        <Trans
          i18n={i18n}
          defaults={tl('auth.passcodeForm.helpLine2')}
          components={{
            email: <ExternalLink to={`mailto:${contactEmail}`}>{contactEmail}</ExternalLink>,
          }}
        ></Trans>
      </Typography>
    </Container>
  );
}

const Container = styled(Box)`
  background: #d9d9d9;
  border-radius: 16px;
  color: ${(props) => props.theme.colors.charcoal};
`;
